import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
    card: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        margin: 0,
        minWidth: 0,
    },
    frame: {
        position: 'relative',
        aspectRatio: '16 / 9',
        borderRadius: 12,
        overflow: 'hidden',
        background: theme.palette.raised,
    },
    iframe: {
        width: '100%',
        height: '100%',
        border: 0,
    },
    thumb: {
        position: 'absolute',
        inset: 0,
        display: 'grid',
        placeItems: 'center',
        width: '100%',
        padding: 0,
        border: 0,
        cursor: 'pointer',
        backgroundColor: 'black',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&:hover $play, &:focus-visible $play': {
            transform: 'scale(1.1)',
            background: theme.palette.primary.main,
        },
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: -2,
        },
    },
    play: {
        display: 'grid',
        placeItems: 'center',
        width: 56,
        height: 56,
        borderRadius: '50%',
        color: '#fff',
        background: 'rgba(10, 10, 14, 0.72)',
        backdropFilter: 'blur(4px)',
        transition: 'transform 0.2s, background 0.2s',
        '& svg': {
            fontSize: 32,
        },
    },
    Loader: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
    },
    caption: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        fontSize: 13,
    },
    name: {
        fontWeight: 600,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    tag: {
        flex: 'none',
        padding: '1px 8px',
        borderRadius: 999,
        fontFamily: theme.fonts.mono,
        fontSize: 11,
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.secondary,
    },
    official: {
        color: theme.palette.accent,
        borderColor: theme.palette.accent,
    },
}));
